import React, { useEffect, useRef } from 'react'
import '../styles/PricingPlans.css'
import { T } from './Translation'

function PricingPlans() {
  const pricingRef = useRef(null)

  useEffect(() => {
    if (window.location.hash === '#pricing' && pricingRef.current) {
      pricingRef.current.scrollIntoView({ behavior: 'smooth' })
    }
  }, [])

  const handleChoosePlan = () => {
    const phoneNumber = '972525815653'
    const message = `היי, אני מעוניין להצטרף לתוכנית של Invitly. אפשר לקבל מידע נוסף ?`
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`
    window.open(whatsappUrl, '_blank')
  }

  const handleAddonClick = () => {
    const phoneNumber = '972525815653'
    const message = `היי, אני מעוניין להוסיף שליחת הזמנות ב-WhatsApp לתוכנית שלי. אפשר לקבל מידע נוסף?`
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`
    window.open(whatsappUrl, '_blank')
  }

  return (
    <section id="pricing" ref={pricingRef} className="pricing-section">
      <h2>
        <T k="ourPricingPlans" />
      </h2>

      {/* Main Plans */}
      <div className="pricing-cards">
        {/* SMS Plan */}
        <div className="pricing-card">
          <div className="plan-channel-tag sms-tag">
            <T k="smsPlanTag" />
          </div>
          <h3>
            <T k="smsPlanName" />
          </h3>
          <p className="price">
            <T k="smsPlanPrice" />
          </p>
          <ul>
            <li><T k="smsPlanFeature1" /></li>
            <li><T k="smsPlanFeature2" /></li>
            <li><T k="smsPlanFeature3" /></li>
            <li><T k="smsPlanFeature4" /></li>
            <li><T k="smsPlanFeature5" /></li>
          </ul>
          <button onClick={handleChoosePlan}>
            <T k="choosePlan" />
          </button>
        </div>

        {/* WhatsApp Plan (featured) */}
        <div className="pricing-card featured">
          <div className="plan-channel-tag whatsapp-tag">
            <T k="whatsappPlanTag" />
          </div>
          <h3>
            <T k="whatsappPlanName" />
          </h3>
          <p className="price">
            <T k="whatsappPlanPrice" />
          </p>
          <ul>
            <li><T k="whatsappPlanFeature1" /></li>
            <li><T k="whatsappPlanFeature2" /></li>
            <li><T k="whatsappPlanFeature3" /></li>
            <li><T k="whatsappPlanFeature4" /></li>
          </ul>
          <button onClick={handleChoosePlan}>
            <T k="choosePlan" />
          </button>
        </div>
      </div>

      {/* Add-on Section */}
      <div className="addon-section">
        <div className="addon-card">
          <div className="addon-badge">
            <T k="whatsappAddonTag" />
          </div>
          <div className="addon-content">
            <div className="addon-info">
              <h3><T k="whatsappAddonName" /></h3>
              <p className="addon-desc"><T k="whatsappAddonDesc" /></p>
            </div>
            <div className="addon-cta">
              <p className="addon-price"><T k="whatsappAddonPrice" /></p>
              <button onClick={handleAddonClick}>
                <T k="contactForAddon" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default PricingPlans
